
import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "../../axios";
import { route } from './routes';

export function useAllMartList() {
    return useQuery([route.GET_MART_LIST], async () => {
      const { data } = await axios.get(route.GET_MART_LIST);
      return data;
    })
  }
  
export function useAllCategoryList({ service }) {
    return useQuery([route.GET_CATEGORIES, service], async () => {
      const { data } = await axios.get(route.GET_CATEGORIES, {
        params: { service }
      });
      return data;
    })
  }
  




  // brand add 
  export function useAddBrand() {
    const queryClient = useQueryClient();
    return useMutation(async (payload) => {
      const { data } = await axios.post(route.ADD_BRAND, payload);
      queryClient.invalidateQueries([route.BRAND_LIST]);
      return data;
    })
  }

  export function useDeleteBrand() {
    const queryClient = useQueryClient();
    return useMutation(async (payload) => {
      const { data } = await axios.post(route.DELETE_BRAND, payload);
      queryClient.invalidateQueries([route.BRAND_LIST]);
      return data;
    })
  }
  
  

  // brand list
  export function useBrandList() {
    return useQuery([route.BRAND_LIST], async () => {
      const { data } = await axios.get(route.BRAND_LIST);
      return data;
    })
  }
  
